import { ReactElement, useCallback, useState } from 'react';
import styled from 'styled-components';

import {
   appendTestableComponentAttributes,
   appendTestableCustomAttribute,
   TestableComponentProps,
} from '@dreryk/react-components';

const StyledBannerLink = styled.a<{ $loaded: boolean }>`
   display: ${(props) => (props.$loaded ? 'block' : 'none')};
   position: relative;
   height: 100px;
   width: 452px;
   overflow: hidden;
   border-radius: 16px;
   cursor: pointer;
`;

StyledBannerLink.displayName = 'StyledBannerLink';

export const StyledBannerImage = styled.img`
   position: absolute;
   transform: translateY(-50%);
   top: 50%;
`;

StyledBannerImage.displayName = 'StyledBannerImage';

type BannerProps = TestableComponentProps & {
   readonly bannerUrl: string;
   readonly targetUrl?: string;
   readonly fallback?: ReactElement;
   readonly onLoad?: VoidFunction;
   readonly onError?: VoidFunction;
};

export const Banner = (props: BannerProps): JSX.Element => {
   const [loaded, setLoaded] = useState<boolean>(false);

   const handleOnLoad = useCallback(() => {
      setLoaded(true);
      props.onLoad?.();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setLoaded, props.onLoad]);

   return (
      <StyledBannerLink
         {...appendTestableComponentAttributes('Banner', props.testId)}
         href={props.targetUrl}
         target={'_blank'}
         $loaded={loaded}
      >
         <StyledBannerImage
            {...appendTestableCustomAttribute('image', props.testId)}
            src={props.bannerUrl}
            onLoad={handleOnLoad}
            onError={props.onError}
         />
      </StyledBannerLink>
   );
};
